<template>
    <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px" class="app-container view-container">
      <BjDivider>
        {{ $t('AddingAnInternalReturnRefundDoc.Basic') }}
        <template slot="right">
            <el-button @click="tryCancel()">{{ $t('cancelText') }}</el-button>
            <el-button type="primary" @click="onConfirm">{{ $t('okText') }}</el-button>
          </template>
      </BjDivider>
      <template>
        <el-row :gutter="10">
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessAfterCsgReturn.table.cusName')" prop="cusName">
             <BjSelectLov v-model="form.cusId" :option-list="CUSTOMER_LIST" @change="cusChange" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderDetail.table.associatedCode')">
             <BjInput v-model="form.thirdCode" type="text" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessAfterCsgReturn.table.reference')" prop="remark">
             <BjInput v-model="form.remark" type="textarea" show-word-limit autosize :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </template>

    <div class="bj-row mt20">
      <BjDivider
        >{{ $t('AddingAnInternalReturnRefundDoc.Product') }}
        <template>
          <el-button type="primary" @click="handleShowFnForDialogSkuList">{{ $t('BusinessAfterCsgReturn.table.add') }}</el-button>
        </template>
      </BjDivider>
      <div class="bj-col bj-col-24" style="border-left:none">
        <el-table :data="form.goodsList" border script max-height="600px" @selection-change="handleSelectionChange">
          <el-table-column prop="standardSkuCode" label="SKU" align="center" />
          <el-table-column prop="barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" align="center" />
          <el-table-column align="center">
            <template #header>
              <span class="red">*</span> {{ $t('goodsSku.detail.qty') }}
            </template>
            <template v-slot="{ row }">
              <BjInputNumber v-model="row.planQty" :min="1" class="full-width" clearable :controls="false" />
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template #header>
              <span class="red">*</span> {{ $t('BusinessAfterCsgReturn.table.checkCounts') }}
            </template>
            <template v-slot="{ row }">
              <BjInputNumber v-model="row.checkCounts" :min="1" class="full-width" clearable :controls="false" />
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template #header>
              <span class="red">*</span> {{ $t('BusinessAfterCsgReturn.table.skuStatus') }}
            </template>
            <template v-slot="{ row }">
              <BjSelectLov v-model="row.skuStatus" :option-list="RETURN_PRODUCT_STATUS" />
            </template>
          </el-table-column>
          <el-table-column prop="" :label="$t('table.operationText')" fixed="right" align="center" width="110">
            <template v-slot="{ row, $index }">
              <el-button @click="onDelete(row, $index)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
      <BjDivider>{{ $t('AddingAnInternalReturnRefundDoc.Picture') }}</BjDivider>
      <div class="mt20">
        <el-form-item label="" style="display: block; height: 100%">
          <BjUpload
            ref="BjUpload"
            class="avatar-uploader"
            :limit="20"
            :limit-size="5 * 1024"
            multiple
            show-file-list
            list-type="picture-card"
            accept="image/png,image/jpeg"
            :accept-list="['image/jpeg', 'image/png']"
            auto-upload
            limit-hide
            @afterUpload="afterUpload"
            @remove="onRemoveUrl"
          >
            <template slot="default">
              <i class="el-icon-plus avatar-uploader-icon" />
            </template>
            <template slot="tip">
              <span style="color: red">{{ $t('BusinessAfterCsgReturn.uploadHindText1') }}:</span> {{ $t('BusinessAfterCsgReturn.uploadHindText2') }}
              <!-- 支持上传多附件，非必填 -->
              <!-- 可拖拽图片调整顺序,支持上传文件格式、尺寸根据各平台与定，大小不超过5M -->
            </template>
          </BjUpload>
        </el-form-item>
      </div>
    <!-- sku商品列表 -->
      <BjDialogList ref="dialogList" :config="$BjDialogListConfig.skuDefault('SelectSKUText',{defaultQuery: defaultQuery, columns: columns, search: search, actionApi: actionApi})" @confirm="onAddDialogConfirm" />
    </el-form>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import {thirdReturnApi, goodsApi, userApi} from '@/api';
import BjUpload from '@/components/BjUpload/index';
import { RETURN_PRODUCT_STATUS } from '@/utils/constants';

const getDefaultForm = () => {
  return {
    backInventoryQty: null, // 返回库存数量 ,
    backInventoryRemark: null, //  返回库存备注 ,
    damagedQty: null, //  已损坏数量 ,
    damagedRemark: null, //  已损坏备注 ,
    barCode: null, // 条形码 ,
    checkCounts: null, // 检查计数 ,
    cusId: null, //  客户ID ,
    cusName: null, //  客户名称 ,
    outRefundNo: null, //  第三方退货单号 ,
    planQty: null, //  单据数量 ,
    remark: null, //  备注 ,
    comment: null,
    skuCode: null, //  sku编码 ,
    skuName: null, //  sku名称 ,
    skuStatus: null, //  sku状态:Complete-完整的,Damaged-已损坏 ,
    thirdPartyReturnOrderMaterialList: [],
    goodsList: [],
    status: 'Pending',
    thirdCode: null // 关联单号
  };
};
export default {
  name: 'BusinessAfterCsgReturnAdd',
  components: {
    BjUpload,
  },
  mixins: [viewMiXin],
  data() {
    return {
      RETURN_PRODUCT_STATUS,
      colSpan: 8,
      form: getDefaultForm(),
      CUSTOMER_LIST: [],
      actionApi: goodsApi.getSkuAuditList,
      defaultQuery: {
        status: [3, 4, 5]
      },
      columns: [
        {
          prop: 'skuCode',
          label: 'BjDialogListConfig.SKUcode',
          width: 160,
        },
        {
          prop: 'skuName',
          label: 'BjDialogListConfig.SKUname',
          width: 160,
        },
        {
          prop: 'barCode',
          label: 'BarCode',
          width: 160,
        },
      ],
      search: [
        {
          placeholder: 'BjDialogListConfig.entername',
          key: 'skuName',
        },
        {
          placeholder: 'BjDialogListConfig.entercode',
          key: 'skuCode',
        },
        {
          placeholder: 'BusinessAfterCsgReturn.barCodeText',
          key: 'barCode',
        },
      ],
      rules: {
        'cusName': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
    };
  },
  computed: {
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    cusChange(e, item) {
      if (!item.label) return;
      this.form.cusName = item.label;
    },
    // 获取客户列表
    async getUserList() {
      const queryParams = {
        customerType: 'C',
        size: 999
      };
      const res = await userApi.getUserList(queryParams);
      if (!res.content.length) return;
      this.CUSTOMER_LIST = res.content.map(item => {
        return {
          label: item.cusName,
          value: item.cusId
        };
      });
    },
    // 添加商品
    async onAddDialogConfirm(data) {
      if (!data) return;
      this.form.goodsList = [];
      this.form.goodsList.push({
        barCode: data[0].barCode,
        skuCode: data[0].skuCode,
        skuName: data[0].skuName,
        planQty: 1,
        checkCounts: 1,
        skuStatus: 'Complete'
      });
    },

    // BjDialogSkuList 选择商品 show
    handleShowFnForDialogSkuList() {
      if (this.form.cusId) {
        this.defaultQuery['cusId'] = this.form.cusId;
        this.$nextTick(() => {
          this.$refs.dialogList.show();
        });
      } else {
        this.$message.warning(this.$t('BusinessAfterCsgReturn.hintMessageText1'));
      }
    },
    onDelete(row, index) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
          row
            ? this.form.goodsList.splice(index, 1)
            : (this.form.goodsList = this.form.goodsList.filter(
              row => !this.selection.map(e => e.skuCode).includes(row.skuCode),
            ));
        })
    },
    handleSelectionChange(selection) {
    //   // this.selection = selection;
    },
    // 获取 上传的 新数据 并 合并到旧数据
    afterUpload(url) {
      this.form.thirdPartyReturnOrderMaterialList.push({detailImage: url});
    },
    onRemoveUrl(file) {
      this.form.thirdPartyReturnOrderMaterialList.splice(
        this.form.thirdPartyReturnOrderMaterialList.findIndex(e => e.detailImage === file.url),
        1,
      );
    },
    /** 确定 */
    onConfirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return this.$scrollToFormError();
        if (!this.form.goodsList.length) return this.$message.error(this.$t('BusinessAfterCsgReturn.hintMessageText2'));
        if (this.form.thirdPartyReturnOrderMaterialList.length < 3) return this.$message.warning(this.$t('BusinessAfterCsgReturn.hintMessageText3'));
        for (const item of this.form.goodsList) {
          if (!item.planQty || !item.checkCounts || !item.skuStatus) {
            return this.$message.error(this.$t('BusinessAfterCsgReturn.hintMessageText4'));
          }
        }
        this.toConfirmApi();
      });
    },
    toConfirmApi() {
      const API_DATA = {
        ...this.form,
        ...this.form.goodsList[0]
      };
      delete API_DATA.goodsList;
      this.addApi(API_DATA);
    },
    addApi(API_DATA) {
      thirdReturnApi.addThirdPartyReturnOrder(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.complete('BusinessAfterCsgReturnIndex');
            // eslint-disable-next-line no-undef
            this.form = defaultForm();
          }, 500);
        }
      });
    },
  },
};
</script>

